import React from "react";
import { CircularProgress, RaisedButton, TextField } from "material-ui";
import { Link } from "react-router";
import Helmet from "react-helmet";

import connectToStores from "alt-utils/lib/connectToStores";
import PersonActions from "../actions/PersonActions";
import PersonStore from "../stores/PersonStore";
import GlobalNotificationActions from "../actions/GlobalNotificationActions";

@connectToStores
class Activate extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      username: "",
      password: "",
      confirmPassword: "",
      hasStartedConfirming: false,
      activating: false
    };

    this._activate = this._activate.bind(this);
  }

  static getStores() {
    return [PersonStore];
  }

  static getPropsFromStores() {
    return PersonStore.getState();
  }

  static get contextTypes() {
    return {
      router: React.PropTypes.object.isRequired,
      tenant: React.PropTypes.object
    };
  }

  _activate() {
    this.setState({ activating: true });
    PersonActions.edit({ password: this.state.password });
  }

  componentDidMount() {
    PersonActions.clearErrors();
    PersonActions.logout();

    try {
      let [username, password] = atob(this.props.location.query.token).split(
        ";"
      );
      this.setState({ username: username });
      PersonActions.login(username, password, /* ignoreLoginErrors */ true);
    } catch (e) {
      PersonActions.editFailed(e);
    }
  }

  componentWillReceiveProps(newProps) {
    if (this.state.activating && newProps.isLoggedIn) {
      GlobalNotificationActions.notify.defer(
        `Your account has been activated successfully! You are now logged in.`
      );
      this.context.router.push("/welcome");
    }
  }

  getStyles() {
    return {
      container: {
        margin: "20px auto",
        marginTop: "10%",
        width: 270,
        fontSize: "11pt"
      },
      actions: {
        marginTop: 10,
        textAlign: "center"
      },
      error: {
        color: "#FF4136"
      }
    };
  }

  render() {
    let styles = this.getStyles(),
      error = this.props.loginErrorMessage || this.props.editErrorMessage;

    if (error && error.indexOf("Invalid password") !== -1) {
      return (
        <div
          style={Object.assign({}, styles.container, styles.error, {
            textAlign: "center"
          })}
        >
          This account has already been activated.
          <div style={styles.actions}>
            <RaisedButton
              label={"Login instead"}
              primary={true}
              onClick={() =>
                this.context.router.push({
                  pathname: "/login",
                  state: { username: this.state.username }
                })
              }
            />
          </div>
        </div>
      );
    }

    return (
      <div style={styles.container}>
        <Helmet title="Activate account" />
        <div>
          {error ? (
            <div style={styles.error}>Failed to activate account: {error}</div>
          ) : (
            <div>
              Welcome to {this.context.tenant.display_name}! To continue, please
              set a password for your account.
            </div>
          )}
          <form>
            <div>
              <TextField
                floatingLabelText="Email address"
                value={this.state.username}
                disabled={true}
              />
            </div>
            <div>
              <TextField
                floatingLabelText="New password"
                floatingLabelFixed={true}
                value={this.state.password}
                onChange={e => this.setState({ password: e.target.value })}
                type="password"
                disabled={this.props.editInProgress}
              />
            </div>
            <div>
              <TextField
                floatingLabelText="Confirm new password"
                floatingLabelFixed={true}
                value={this.state.confirmPassword}
                onChange={e =>
                  this.setState({
                    hasStartedConfirming: true,
                    confirmPassword: e.target.value
                  })
                }
                errorText={
                  this.state.hasStartedConfirming &&
                  this.state.password !== this.state.confirmPassword
                    ? "The passwords do not match."
                    : null
                }
                type="password"
                disabled={this.props.editInProgress}
              />
            </div>
            <div style={styles.actions}>
              <RaisedButton
                label={
                  this.props.editInProgress
                    ? "Activating..."
                    : "Activate account"
                }
                disabled={
                  this.props.editInProgress ||
                  !this.state.password ||
                  this.state.password !== this.state.confirmPassword
                }
                primary={true}
                onClick={this._activate}
              />
            </div>
          </form>
        </div>
      </div>
    );
  }
}

export default Activate;



// WEBPACK FOOTER //
// ./src/app/components/activate.jsx